(function () {

   const swiperThumb = new Swiper(".thumbSwiper", {
      spaceBetween: 20,
      slidesPerView: 4.2,
      mousewheel: {
          forceToAxis: true
        },
     breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.2,
           spaceBetween: 8,
        },
        // when window width is >= 640px
        768: {
          slidesPerView: 3,
           spaceBetween: 8,
        },
         1024: {
          slidesPerView: 4,
            spaceBetween: 8,
        }
      },
      freeMode: true,
      watchSlidesProgress: true,
     scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
       },

    });

  //Quick View

$(document).ready(function () {
	$.getScript("//cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js").done(function () {
		quickView();
	});
});


function quickView() {
	$(".open-video-modal").click(function (e) {
		e.preventDefault();
         let videoUrl = $(this).attr('data-url');
      let videoImg = $(this).attr('data-img');
		
        Fancybox.show([
          {
            src: videoUrl,
            thumb: videoImg,
          }
        ]);
      });  
};

document.addEventListener('shopify:section:load', function () {
	quickView();
});


  

})();